import classNames from 'clsx';
import { ReactComponent as IconClose } from 'img/icons/remove.svg';
import React, { MouseEventHandler } from 'react';
import { useFirstEffect } from 'reactApp/hooks/useFirstEffect';
import { withRequiredHtmlContentHOC } from 'reactApp/ui/TopBanner/withRequiredHtmlContentHOC';

import styles from './TopBanner.css';

export interface ITopBannerComponentProps {
    htmlContent: string;
    onClose: MouseEventHandler<HTMLDivElement>;
    onClick: MouseEventHandler<HTMLDivElement>;
    onShow: () => void;
    height?: number;
    closeDarkTheme?: boolean;
}

const TopBannerComponent: React.VFC<ITopBannerComponentProps> = ({
    onClose,
    onClick,
    onShow,
    htmlContent,
    height = 60,
    closeDarkTheme = false,
}) => {
    useFirstEffect(onShow);

    return (
        <div
            className={styles.root}
            style={{
                height,
            }}
        >
            <div className={styles.content} onClickCapture={onClick} dangerouslySetInnerHTML={{ __html: htmlContent }} />
            <div
                className={classNames(styles.close, {
                    [styles.close_dark]: closeDarkTheme,
                })}
                onClickCapture={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onClose(event);
                }}
            >
                <IconClose width={22} height={22} />
            </div>
        </div>
    );
};

export const TopBanner = withRequiredHtmlContentHOC(TopBannerComponent);
